import React from 'react';
import { useDispatch } from '~/redux';
import { Button } from '~/components/common';
import { closeModal } from '~/redux/actions';
import { ModalContainer, ModalBody, ModalFooter } from './ResourceModalCommon';
import ReactGA from 'react-ga';
import stripHTML from '~/utils/stripHTML';
import config from '~/config';

interface Props {
  link: string;
  title: string;
}
const LeavingPromptModal: React.FC<Props> = ({ link, title }) => {
  const dispatch = useDispatch();

  function handleClose() {
    dispatch(closeModal());
  }

  function openExternalLink(url) {
    window.open(url, '_blank');

    ReactGA.outboundLink({
      label: stripHTML(title)
    },
    () => {
      if (config.debug) { console.log('open resource link', link); }
    })

    handleClose();
  }

  return (
    <ModalContainer>
      <ModalBody>
        <div>
          <p>You are now<br/>leaving this site.</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          variant='secondary'
          onClick={() => openExternalLink(link)}
        >
          Proceed
        </Button>
        <Button variant='primary' onClick={handleClose}>
          Cancel
        </Button>
      </ModalFooter>
    </ModalContainer>
  )
}
export default LeavingPromptModal;



// WEBPACK FOOTER //
// ./src/components/modals/LeavingPromptModal.tsx